import { render } from "./SearchSelect.vue?vue&type=template&id=fb926dd0&scoped=true"
import script from "./SearchSelect.vue?vue&type=script&lang=js"
export * from "./SearchSelect.vue?vue&type=script&lang=js"

import "./SearchSelect.vue?vue&type=style&index=0&id=fb926dd0&scoped=true&lang=css"

import exportComponent from "/opt/vr23-npm/htdocs/templates/vr23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb926dd0"]])

export default __exports__